const GROUPS = [
  {
    label: "Frontend",
    items: [
      "React.js",
      "Next.js",
      "Angular",
      "TypeScript",
      "JavaScript (ES6+)",
      "Tailwind CSS",
    ],
  },
  {
    label: "Backend",
    items: [
      "Node.js",
      "Express.js",
      "Laravel (PHP)",
      "REST APIs",
      "JWT / OAuth",
    ],
  },
  {
    label: "Databases",
    items: ["MongoDB", "MySQL", "PostgreSQL", "Firebase"],
  },
  {
    label: "AI Tooling",
    items: [
      "Claude Code",
      "Prompt engineering",
      "AI-assisted development",
      "AI-assisted Rust microservices",
    ],
  },
  {
    label: "Testing",
    items: ["Playwright (E2E)", "Unit Testing", "Postman"],
  },
];

function Capabilities() {
  return (
    <section className="section" id="capabilities">
      <div className="wrap">
        <div className="section-head reveal">
          <h2 className="section-title">Capabilities</h2>
          <p className="section-note">
            The tools and technologies I reach for most.
          </p>
        </div>

        {GROUPS.map((g, i) => (
          <div className="cap-group reveal" data-d={i || undefined} key={g.label}>
            <div className="cap-label">{g.label}</div>
            <div className="cap-items">
              {g.items.map((item) => (
                <span className="cap-item" key={item}>
                  {item}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Capabilities;
